import { Alert, Button } from 'antd';
import apiCalls from 'src/api/apiCalls';
import { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from 'src/components/shared/loader.component';
import { NumericFormat } from 'react-number-format';
import Wallets from './wallets';
import HeaderComponent from '../header';
const CardDetails = () => {
  const [details, setDetails] = useState({});
  const [errorMsg, setErrorMsg] = useState(null);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const shouldLog = useRef(true);
  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  const cardName = decodeURIComponent(pathSegments[pathSegments.length - 1]);

  useEffect(() => {
    if (shouldLog.current) {
      getCardDetails(params?.id);
      shouldLog.current = false;
    }
  }, [params]);
  const getCardDetails = async (id) => {
    setLoader(true);
    const response = await apiCalls.cardDetails('AvailableCards', id);
    if (response.ok) {
      setDetails(response.data);
    } else {
      setErrorMsg(apiCalls.isErrorDispaly(response));
    }
    setLoader(false);
  };
  const handleBack = useCallback(() => {
    window.scrollTo(0, 0);
    navigate('/services');
  }, [navigate]);
  const closeErrorHandler = useCallback(() => {
    setErrorMsg(null);
  }, []);

const breadCrumbList = [
  { id: "1", bname: "Services", url: "/services" },
  { id: "2", bname: cardName || "Card Name" }
]
  return (
    <>
    <div><HeaderComponent breadCrumbList={breadCrumbList} /></div>
    <div>
      {loader && <Loader loaderClassname='p-static' />}
      {errorMsg !== null && (
        <Alert
          className='mb-6'
          type='error'
          description={errorMsg}
          onClose={closeErrorHandler}
          showIcon
          closable
        />
      )}
      {!loader && (
        <>
          <div className='card-section min-hw'>
            <img
              className='card-image'
              src={
                details?.cardImage ||
                'https://digibankstoragespace.blob.core.windows.net/images/admindefault-card.png'
              }
              alt='Card'
            />
          </div>
          <h1 className='text-titleColor text-2xl font-semibold mb-2 mt-4'>
            Program Details
          </h1>
          <div className='grid xl:grid-cols-4 md:grid-cols-3 gap-4 border border-StrokeColor md:p-4 p-2 rounded-5'>
            <Field label='Program ID' value={details?.cardTypeId} />
            <Field label='Card Name' value={details?.cardName} />
            <Field label='Bin' value={details?.bin} />
            <Field label='Card Currency' value={details?.cardCurrency} />
            <Field label='Card Type' value={details?.cardType} />
            <Field label='Association' value={details?.cardAssoc} />
            <Field label='Consumption Method' value={details?.consumptionMethod} />
            <Field label='Maintenance Unit' value={details?.maintenanceUnit} />
            <Field label='Review Time' value={details?.reviewTime} />
            <Field label='KYC Requirement' value={details?.kycRequirement} />
            <Field label='Supported Platforms' value={details?.supportedPlateforms} />
            <div className=''>
              <p className='summary-label'>Status</p>
              <p className={`${details?.isActive ? '!text-statusred' : '!text-statusGreen'}`}>
                {details?.isActive ? 'Inactive' : 'Active'}
              </p>
            </div>
            <Field
              label='Need Photo For ActiveCard'
              value={details?.needPhotoForActiveCard === false ? 'False' : 'True'}
            />
            <Field
              label='Need Photo For Operate Card'
              value={details?.needPhotoForOperateCard === false ? 'False' : 'True'}
            />
          </div>
          <h1 className='text-titleColor text-2xl font-semibold mb-2 mt-7'>Program Limits</h1>
          <div className='grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-4 gap-4 border border-StrokeColor md:p-4 p-2 rounded-5'>
            <AmountField label='Monthly Recharge Limit' value={details?.monthlyRechargeLimit} currency={details?.cardCurrency} />
            <AmountField label='Daily Recharge Limit' value={details?.dailyRechargeLimit} currency={details?.cardCurrency} />
            {details?.cardType === 'Physical' && (
              <AmountField label='ATM Daily Withdrawl Limit' value={details?.aTMDailyWithdrawlLimit} currency={details?.cardCurrency} />
            )}
            <AmountField label='Spending Limit per day' value={details?.spendingLimit} currency={`${details?.cardCurrency} / day`} />
            <AmountField label='Single Recharge Limit' value={details?.sinleRechargeLimit} currency={details?.cardCurrency} />
            <AmountField label='Per Transaction Limit' value={details?.perTransactionLimit} currency={details?.cardCurrency} />
          </div>
          <h1 className='text-titleColor text-2xl mb-2 mt-7 font-semibold'>Charges</h1>
          <div className='grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-4 gap-4 border border-StrokeColor md:p-4 p-2 rounded-5'>
            <AmountField label='Card Creation Fee' value={details?.actualCardFee} currency={details?.cardCurrency} defaultValue='0' />
            <AmountField label='First Recharge Amount' value={details?.firstRechargeAmount} currency={details?.cardCurrency} defaultValue='0' />
            <AmountField label='Minimum Recharge Amount' value={details?.rechargeMin} currency={details?.cardCurrency} />
            <AmountField label='Maximum Recharge Amount' value={details?.rechargeMax} currency={details?.cardCurrency} defaultValue='0' />
            <AmountField label='Recharge Fee (%)' value={details?.rechargeFee} suffix='%' defaultValue='0' />
            <AmountField label='Maintenance Fee' value={details?.maintenanceFee} currency={details?.cardCurrency} />
            {details?.cardType === 'Physical' && (
              <AmountField label='ATM Withdrawal Fee' value={details?.atmWithdrawlFee} currency={details?.cardCurrency} suffix='%' defaultValue='0' />
            )}
            <AmountField label='Freight Fee' value={details?.freightFee} currency='USDT' decimalScale={8} />
            <AmountField label='Card Cancellation Min Fee' value={details?.cardCancellationMinFee} currency={details?.cardCurrency} defaultValue={`0 ${details?.cardCurrency}`} />
            <AmountField label='Card Cancellation Max Fee (%)' value={details?.cardCancellationMaxFee} suffix='%' defaultValue='0' />
          </div>
          <h1 className='text-titleColor text-2xl mb-2 mt-7 font-semibold'>Wallets</h1>
          <Wallets />
          <div className='mt-4 text-right mb-6'>
            <Button className='primary-btn' onClick={handleBack}>
              Back
            </Button>
          </div>
        </>
      )}
    </div>
    </>
  );
};

const Field = ({ label, value }) => (
  <div className=''>
    <p className='summary-label'>{label}</p>
    <p className='summary-value word-wrap'>{value || ''}</p>
  </div>
);

const AmountField = ({ label, value, currency = '', suffix = '', decimalScale = 2, defaultValue = '' }) => {
  const suffixhandler = suffix ? ` ${suffix}` : '';
  return<div className=''>
    <p className='summary-label'>{label}</p>
    <p className='summary-value'>
      {value !== undefined && value !== null ? (
        <>
          <NumericFormat
            value={value}
            decimalScale={decimalScale}
            thousandSeparator={true}
            thousandsGroupStyle='lakh'
            displayType='text'
          />
          {` ${currency}${suffixhandler}`}
        </>
      ) : (
        defaultValue
      )}
    </p>
  </div>
};
export default CardDetails;
